<div class="container-fluid">
    <div class="row">
        <div class="col-md-3">
            <nj-form-item [hasError]="(this.Instruction.units ?? '') == ''" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isRequired]="true" [isFloatingLabel]="true" iconName="keyboard_arrow_down" [isSelect]="true"
                inputId="BMUs">
                <select njFormField id="BMUs" [(ngModel)]="Instruction.units">
                    <option *ngFor="let unit of BMUList" value='{{unit}}'>{{unit}}</option>
                </select>
                <ng-container njFormLabel>Unit</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row">
        <div class="col-md-3">
            <nj-form-item [hasError]="(this.Instruction.issuedFrom?.toString() ?? '') == ''" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="EventStartTime" [isRequired]="true">
                <input type="date" id="EventStartTime" njFormField [(ngModel)]="Instruction.issuedFrom" />
                <ng-container njFormLabel>Issued From</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-3">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="EventStartTime">
                <input type="date" id="EventStartTime" njFormField [(ngModel)]="Instruction.issuedTo" />
                <ng-container njFormLabel>Issued To</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-6">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="dateComments" >
                <input type="text" id="dateComments" njFormField [(ngModel)]="Instruction.dateComment" />
                <ng-container njFormLabel>Date Comments</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row" [style]="'min-height: 36px'">
        <nj-radio-group errorMessage="" [(value)]="InstructionType" [hasError]="false" orientation="row">
            <nj-radio inputId="RegularInstruction" name="InstructionType" value="REGULAR">
                Regular Instruction
            </nj-radio>
            <nj-radio inputId="Overwrite" name="InstructionType" value="OVERWRITE">
                Overwrite Instruction
            </nj-radio>
        </nj-radio-group>
    </div>
    @if (InstructionType == "REGULAR")
    {
    <div class="row">
        <div class="col-md-2">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="StrikePrice" [isRequired]="true">
                <input id="StrikePrice" type="number" [(ngModel)]="Instruction.strikePrice" njFormField min="0"
                    [disabled]="false" />
                <ng-container njFormLabel>Strike Price</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-2">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="FixedCosts" [isRequired]="true">
                <input id="FixedCosts" type="number" [(ngModel)]="Instruction.fixedCosts" njFormField min="0"
                    [disabled]="false" />
                <ng-container njFormLabel>Fixed Costs</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-2">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="NegativePriceTrigger" [isRequired]="true">
                <input id="NegativePriceTrigger" type="number" [(ngModel)]="Instruction.negativePriceTrigger"
                    njFormField min="0" [disabled]="false" />
                <ng-container njFormLabel>Negative Price Trigger</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
    </div>
    }
    @else
    {
    <div class="row">
        <div class="col-md-3">
            <nj-multi-select [isFloatingLabel]="true" inputId="RelevantSettlementPeriods"
                listNavigationLabel="listNavigationLabel" buttonDefaultValueLabel="buttonDefaultValueLabel"
                fieldLabel="fieldLabel">
                <ng-container njSelectOptions>
                    <li nj-list-item *ngFor="let li of SettlementPeriods" value='{{li.Id}}'> {{li.Description}}</li>
                </ng-container>
                <ng-container njFormLabel>Relevant Settlement Periods</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-multi-select>
        </div>
        <div class="col-md-9">
            <h3>-1 Bid Offer Pair</h3>
<!--
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="minusOne_volume" [isRequired]="true">
                <input id="minusOne_volume" type="number" [(ngModel)]="bidOfferPair.minusOne_volume" njFormField min="0"
                    [disabled]="false" />
                <ng-container njFormLabel>Fixed Costs</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
-->
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="minusOne_mainBid" [isRequired]="true">
                <input id="minusOne_mainBid" type="number" [(ngModel)]="bidOfferPair.minusOne_mainBid" njFormField
                    min="0" [disabled]="false" />
                <ng-container njFormLabel>Main bid</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="minusOne_matchingOffer" [isRequired]="true">
                <input id="minusOne_matchingOffer" type="number" [(ngModel)]="bidOfferPair.minusOne_matchingOffer"
                    njFormField min="0" [disabled]="false" />
                <ng-container njFormLabel>Matching offer</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
            <h3>+1 Bid Offer Pair</h3>
<!--
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="plusOne_volume" [isRequired]="true">
                <input id="plusOne_volume" type="number" [(ngModel)]="bidOfferPair.plusOne_volume" njFormField min="0"
                    [disabled]="false" />
                <ng-container njFormLabel>Fixed Costs</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
-->
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="plusOne_mainBid" [isRequired]="true">
                <input id="plusOne_mainBid" type="number" [(ngModel)]="bidOfferPair.plusOne_mainBid" njFormField min="0"
                    [disabled]="false" />
                <ng-container njFormLabel>Matching bid</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="plusOne_matchingOffer" [isRequired]="true">
                <input id="plusOne_matchingOffer" type="number" [(ngModel)]="bidOfferPair.plusOne_matchingOffer"
                    njFormField min="0" [disabled]="false" />
                <ng-container njFormLabel>Main offer</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>

        </div>
    </div>
    }
    <div class="row">
        <div class="col-md-12">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="Comments">
                <textarea id="Comments" [(ngModel)]="Instruction.comments" njFormField maxlength="1000"></textarea>
                <ng-container njFormLabel>Comments</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row">&nbsp;</div>
    <div class="row">
        <div class="col-md-3">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="SaveInstruction()">
                Save
            </nj-button>
        </div>
        <div class="col-md-3">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                [style]="'margin-top: 10px;'" (buttonClick)="Cancel()">
                Cancel
            </nj-button>
        </div>
    </div>
</div>